import React from 'react';
import { CheckCircle, XCircle, Minus } from 'lucide-react';

/**
 * Agreement indicator for one field of one decision.
 *
 * Three states, and the third is not a synonym for the second:
 *   true  — the human labelled this field and matched the AI
 *   false — the human labelled this field and the AI was wrong
 *   null  — nobody has labelled this field yet
 *
 * "Not yet labelled" must never render as a disagreement. The whole point of
 * the ground-truth screen is the ≥90% agreement number, and an unlabelled row
 * counted as a miss would understate it.
 *
 * Extracted from DecisionDrawer so the drawer, the decisions table and the
 * label panel all render agreement the same way.
 */

const AGREE = {
  Icon: CheckCircle,
  cls: 'text-[var(--boss-success-text)]',
  text: 'matches the AI',
};
const DISAGREE = {
  Icon: XCircle,
  cls: 'text-[var(--boss-danger-text)]',
  text: 'differs from the AI',
};
const UNLABELLED = {
  Icon: Minus,
  cls: 'text-boss-text-muted',
  text: 'not yet labelled',
};

export function matchMeta(val) {
  if (val === true) return AGREE;
  if (val === false) return DISAGREE;
  return UNLABELLED;
}

export default function MatchIcon({ val, field, size = 14, className = 'mr-1' }) {
  const meta = matchMeta(val);
  const { Icon } = meta;
  const description = field ? `${field} ${meta.text}` : meta.text;
  return (
    <span className={`inline-flex items-center align-middle ${className}`} title={description}>
      <Icon size={size} className={`${meta.cls} shrink-0`} aria-hidden="true" />
      <span className="sr-only">{description}</span>
    </span>
  );
}
